export default "__VITE_ASSET__TW7aaiwi__"